import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const PaperPlane = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  fillDarkMode = COLOR.PRIMARY.DARK_500,
  styles
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M21.5 2L2 12l7.5 3L19 7.5l-5.5 5.5L21.5 22l2-20z'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </svg>
  );
};

export default PaperPlane;
